
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface MessageAvatarProps {
  type: "user" | "seller" | "ai" | "system";
  merchantName: string;
}

const MessageAvatar = ({ type, merchantName }: MessageAvatarProps) => {
  const initial = merchantName.charAt(0);
  
  return (
    <Avatar className="h-8 w-8">
      {type === "user" ? (
        <>
          <AvatarFallback>U</AvatarFallback>
          <AvatarImage src="/placeholder.svg" />
        </>
      ) : type === "seller" ? (
        <>
          <AvatarFallback className="bg-orange-100 text-orange-700">
            {initial}
          </AvatarFallback>
        </>
      ) : (
        <>
          <AvatarFallback className="bg-green-100 text-green-700">
            AI
          </AvatarFallback>
        </>
      )}
    </Avatar>
  );
};

export default MessageAvatar;
